export const SET_DEALS = 'setDeals'
export const SET_DEAL = 'setDeal'
export const RESET_STATE = 'resetState'
export const SET_DEALS_BY_CLIENT = 'setDealsByClient'
export const SET_DEALS_BY_MONTH = 'setDealsByMonth'

export const SET_USER = 'setUser'
export const SET_USERS = 'setUsers'
export const SET_PARTNER_ID = 'setPartnerId'
export const RESET_USER_STATE = 'resetUserState'